module.exports = __webpack_public_path__ + "img/page_desarrolla_slider1.1f0edb7e.png";